import { render, staticRenderFns } from "./productSales.vue?vue&type=template&id=57b2c682&scoped=true&"
import script from "./productSales.vue?vue&type=script&lang=js&"
export * from "./productSales.vue?vue&type=script&lang=js&"
import style0 from "./productSales.vue?vue&type=style&index=0&id=57b2c682&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b2c682",
  null
  
)

export default component.exports